<template>
  <transition name="common-fade">
    <div
      v-show="isShowDropdown"
      class="search-dropdown"
      :style="dropdownStyle"
    >
      <section class="dropdown-item-list">
        <slot />
      </section>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'DropDown',
  props: {
    isShowDropdown: false,
    parentNode: null,
    dropdownStyles: {},
  },
  computed: {
    dropdownStyle() {
      return Object.assign(this.dropdownStyles, {
        height: '60px',
      })
    },
  },
  mounted() {
    document.body.addEventListener('click', this.closeCallback)
  },
  destroyed() {
    document.body.removeEventListener('click', this.closeCallback)
  },
  methods: {
    closeCallback(e) {
      const { target } = e
      if (!this.parentNode || !this.parentNode.contains(target)) {
        this.$emit('close')
      }
    },
  },
}
</script>
<style lang="less">
.search-dropdown {
  position: absolute;
  color: #1B2733;
  // right: 0;
  z-index: 100;
  // background-color: red;
  background-color: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
  border-radius: 2px;
  overflow: hidden;
  // min-width: 148px;
  min-width: 172px;
  height: auto!important;
  // padding: 8px 0;
  // min-height: 400px;
  div {
    margin: 0!important;
    float: initial!important;
  }
  .dropdown-item-list {
    padding: 8px 0;
  }
}
.common-fade-leave-active, .common-fade-enter-active {
  transition: max-height 0.3s;
  // 经测试，这里如果100%，伸缩长度最佳，但是由于不同dom加载时间差异，导致动画卡顿
  // 完美解决方法需要考虑用js
  max-height: 800px;// 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.common-fade-enter, .common-fade-leave-to {
  max-height: 0;
  // height: 0;
}
</style>
